var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
export class Alfatron21e {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: '#GET_FIRMWARE_VERSION',
                next: /@V[\d\.]+/i,
            },
        ];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#GET_FIRMWARE_VERSION`, /@V([\d\.]+)|COMMAND ERROR/i, tags);
                return match[1] ? match[1] : 'unknown';
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#GET_AV`, /@AV\s+(C|H)/i, tags);
                return match[1] ? match[1] : this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`#SET_AV ${value}`, /@AV\s+(C|H)/i, tags);
                return match[1] ? match[1] : this.state.videoMatrixRoutes.values[key];
            }),
            asyncHandlers: {
                regExp: /@AV (C|H)/i,
                callback: (match) => {
                    this.state.videoMatrixRoutes.update('1', match[1]);
                },
            },
        };
        // polling
        this.polls = [{ intervalMs: 3000, controls: ['videoMatrixRoutes'] }];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.socket.sendAsync(`#SET_AUTO_SWITCH ${(config === null || config === void 0 ? void 0 : config.autoSwitchVideoInputs) ? '1' : '0'}`, ['configure']);
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
Alfatron21e.driverType = 'socketDriver';
Alfatron21e.key = '-MZNW9MS_bzl8bKlpSvl';
Alfatron21e.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r\n',
};
Alfatron21e.socketOptions = [
    Object.assign(Object.assign({}, Alfatron21e.baseSocketOptions), { port: 4999 }),
];
